import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { ApiResult} from '../../../shared/model/Index';
import { ISeasonSummary } from '../model/seasonsummary';
import { ISearchParam } from '@app/modules/search/model/searchParam';


@Injectable({ providedIn: 'root' })

export class SeasonSummaryService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    search(search: ISearchParam) {
        return this.http.post<ApiResult<ISeasonSummary[]>>(env.apiUrl + 'SeasonSummary/Search', search);
    }
}